import React, { useEffect, useMemo, useState } from "react";
import "./CountDownComponent.scss";

const CountDownComponent = ({
  // Wedding in Colombo time (UTC+05:30)
  target = "2025-12-18T09:00:00+05:30",
  title = "Countdown",
}) => {
  const targetDate = useMemo(() => new Date(target), [target]);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const tick = () => setNow(new Date());
    const id = setInterval(tick, 1000);           // realtime seconds
    return () => clearInterval(id);
  }, []);

  let diff = targetDate.getTime() - now.getTime();
  if (diff < 0) diff = 0;

  const DAY = 86400000, HOUR = 3600000, MIN = 60000, SEC = 1000;

  const days = Math.floor(diff / DAY);
  const remAfterDays = diff % DAY;
  // We’re not displaying hours; minutes/seconds are within the current hour
  const remAfterHours = remAfterDays % HOUR;
  const minutes = Math.floor(remAfterHours / MIN);
  const seconds = Math.floor((remAfterHours % MIN) / SEC);

  const pad2 = (n) => String(n).padStart(2, "0");

  return (
    <section className="cd" aria-label="Wedding Countdown">
      <div className="cd__shell">
        <div className="cd__unit">
          <div className="cd__num">{days}</div>
          <div className="cd__label">Days</div>
        </div>
        <div className="cd__unit">
          <div className="cd__num">{pad2(minutes)}</div>
          <div className="cd__label">Minutes</div>
        </div>
        <div className="cd__unit" aria-live="off">
          <div className="cd__num">{pad2(seconds)}</div>
          <div className="cd__label">Seconds</div>
        </div>
      </div>
    </section>
  );
};

export default CountDownComponent;
